/**
 * Sort order for BaseTable
 */
var SortOrder = {
  /**
   * Sort data in ascending order
   */
  ASC: 'asc',

  /**
   * Sort data in descending order
   */
  DESC: 'desc'
};
export default SortOrder;
//# sourceMappingURL=SortOrder.js.map